const updateClient = (state, action) => {
  if (state === undefined) {
    return {
      clients: [],
      clientsLoading: false,
      client_id: null,
      client: null,
      clientLoading: true,
      error: null,
      clientDiscount: [],
      source: [],
      statusClient: [],
      allClients: [],
    };
  }

  switch (action.type) {
    case "CLIENTS_REQUESTED":
      return {
        ...state.clients,
        clientsLoading: true,
      };

    case "UPDATE_CLIENT":
      return {
        ...state.clients,
        error: null,
        client: action.payload,
        clientLoading: false,
      };
    case "CLIENT_DISCOUNT_LOADED":
      return {
        ...state.clients,
        clientDiscount: action.payload,
      };

    case "CLIENTS_ERROR":
      return {
        ...state.clients,
        clients: [],
        clientsLoading: false,
        error: action.payload,
      };
    case "CLIENTS_LOADED":
      return {
        ...state.clients,
        error: null,
        clients: action.payload,
        clientsLoading: false,
      };
    case "ALL_CLIENTS_LOADED":
      return {
        ...state.clients,
        error: null,
        allClients: action.payload,
        clientsLoading: false,
      };
    case "CLIENT_ID":
      return {
        ...state.clients,
        client_id: action.payload,
      };
    case "CLIENT_REQUESTED":
      return {
        ...state.clients,
        clientLoading: true,
      };

    case "CLIENT_ERROR":
      return {
        ...state.clients,
        client: [],
        clientLoading: false,
        error: action.payload,
      };
    case "CLIENT_LOADED":
      return {
        ...state.clients,
        error: null,
        client: action.payload,
        clientLoading: false,
      };
    case "SOURCE_LOADED":
      return {
        ...state.clients,
        source: action.payload,
      };
    case "STATUS_CLIENT_LOADED":
      return {
        ...state.clients,
        statusClient: action.payload,
      };
    default:
      return state.clients;
  }
};

export default updateClient;
